export default {
    route: {
        hidden: true,
        meta: {
            title: '产品列表'
        }
    }
}
